import { createContext, useContext } from "react";

const ToastContext = createContext();

export function ToastProvider({ children, snackbarRef }) {

  const showToast = (type, message) => {
    snackbarRef.current?.open(type, message);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
